import { type HttpClient } from '@/application/interfaces/http-client';

import { getCategoriesMap } from './get-categories-map';
import { getCategoriesMetadata } from './get-categories-metadata';
import { getProductsMap } from './get-products-map';
import { getProductsMetadata } from './get-products-metadata';

const SiteMapServices = (httpClient: HttpClient.Instance) => ({
  getCategoriesMap: getCategoriesMap(httpClient),
  getProductsMap: getProductsMap(httpClient),

  getProductsMetadata: getProductsMetadata(httpClient),
  getCategoriesMetadata: getCategoriesMetadata(httpClient),
});

export default SiteMapServices;
